import { useSelector } from 'react-redux'
import { getEnv } from '../../app/envs'
import { useCountDown } from '../../app/lib/count-down/useCountDown'
import { selectFreeBets } from '../../app/store/betslip/betslip.selectors'
import { placeBet } from '../../app/store/game/game.state'
import { useAppDispatch } from '../../app/store/store'
import { Clock, Rebet } from '../svgs'
import { FRebet } from './freeRebet.style'

export const FreeRebet = () => {
  const { currency } = getEnv()
  const dispatch = useAppDispatch()

  const freeBetsList = useSelector(selectFreeBets)
  const freeBet = freeBetsList[0]
  const expiry = useCountDown(freeBet)

  return (
    <FRebet onClick={() => dispatch(placeBet())}>
      <div className="rebet" key={freeBet?.free_bet_uid}>
        <div className="rebet__icon">
          <Rebet width="48" height="48" viewBox="0 0 24 24" />
        </div>
        <div className="rebet__txt">
          free rebet {currency} {freeBet?.amount}
        </div>

        <div className="rebet__countdown">
          <div className="icon-clock">
            <Clock width="16" height="16" viewBox="0 0 24 24" />
          </div>
          <div className="time">{expiry?.output}</div>
        </div>
      </div>
    </FRebet>
  )
}
